define.alias("shared/utils/emoji-picker", "settings/utils/emoji-picker");